import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { makeHeadData } from 'lib/commonLib';
import { useTheme } from '@material-ui/core/styles';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import Modal from 'components/organisms/NewModal';
import CurrentStatus from 'components/atoms/CurrentStatus';
import FilterCollection from 'components/organisms/FilterCollection';

const TargetStatisticsModal = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const {
    modal,
    params,
    handleModalClose,
    handleSubmit,
    getModalParam,
    handleMemo,
    pcodeList,
  } = props;

  const tableHead = [
    {
      id: 'REG_DTTM',
      label: t('작성일자'),
      orderFlag: false,
      type: 'date',
      format: 'yyyy-mm-dd',
      displayFlag: true,
      calFlag: false,
    },
    {
      id: 'USER_NAME',
      label: t('작성자'),
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
      calFlag: false,
    },
    {
      id: 'TEXT',
      label: t('내용'),
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
      calFlag: false,
    },
    {
      id: 'ALT_FLAG',
      label: t('관리'),
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
      calFlag: false,
    },
  ];

  return (
    <Modal
      open={modal.open}
      headerTitle={modal.modalTitle}
      handleClose={handleModalClose}
      confirmBtnTitle={modal.confirmBtnTitle}
      confirmBtnOpen={modal.confirmBtnOpen}
      cancelBtnTitle={modal.cancelBtnTitle}
      confirmOnClick={handleSubmit}
    >
      {modal.type === 'thres' && (
        <NewInput
          type="filter"
          label={t('임계치')}
          name="parThresHold"
          value={modal.params.parThresHold}
          params={modal.params}
          callBack={getModalParam}
        />
      )}
      {modal.type === 'memo' &&
        (() => {
          const memoCustomized = {
            ALT_FLAG: {
              makeBody: (rowObj, headsMap) => {
                return (
                  <TableBtnWrap>
                    <NewButton
                      onClick={(e) => handleMemo('modify', rowObj)}
                      disableRipple
                      style={{
                        backgroundColor:
                          rowObj['MEMO_NO'] === modal.params['memoNo']
                            ? theme.palette.common.green
                            : null,
                        color:
                          rowObj['MEMO_NO'] === modal.params['memoNo'] &&
                          '#fff',
                      }}
                    >
                      {rowObj['MEMO_NO'] === modal.params['memoNo']
                        ? t('선택중')
                        : t('수정')}
                    </NewButton>
                    <NewButton
                      onClick={(e) => handleMemo('delete', rowObj)}
                      disableRipple
                      type="delete"
                    >
                      {t('삭제')}
                    </NewButton>
                  </TableBtnWrap>
                );
              },
            },
          };
          return (
            <>
              {modal.data.length > 0 ? (
                <NewTableContainer
                  params={params}
                  getParam={(f) => f}
                  useCustomTable
                  propsList={modal.data}
                  useTotal={false}
                  useFetch={false}
                  useToolBar={false}
                  usePagenation={false}
                  propsHeadCells={makeHeadData(tableHead)}
                  customized={memoCustomized}
                  rowsPerPage={-1}
                />
              ) : (
                t('작성된 테이터가 없습니다.')
              )}
              <NewInput
                type="filter"
                label={t('메모를 입력해주세요.')}
                name="memo"
                value={modal.params.memo}
                params={modal.params}
                callBack={getModalParam}
                multiline
                rows={4}
                style={{ width: '100%', maxWidth: 'none', marginTop: 15 }}
              />
              <NewButton
                onClick={(e) =>
                  !!modal.params['memoNo']
                    ? handleMemo('set')
                    : handleMemo('add')
                }
                disableRipple
                style={{ width: '100%', marginTop: 15 }}
              >
                {!!modal.params['memoNo'] ? t('수정') : t('등록')}
              </NewButton>
            </>
          );
        })()}
      {modal.type === 'target' &&
        (modal.data['noData'] ? (
          <div style={{ minWidth: 300 }}>
            <CurrentStatus type="noData" />
          </div>
        ) : (
          <>
            {t('가중치일괄변경타이틀', {
              siteName: modal.params['siteName'],
            })}
            {(() => {
              let result = [];
              for (let key in modal.data) {
                result.push(
                  <NewInput
                    key={key}
                    label={key}
                    name={key}
                    value={modal.params[key]}
                    params={modal.params}
                    callBack={getModalParam}
                    style={{ width: 50, margin: '0 5px' }}
                  />
                );
              }
              return (
                <div
                  style={{
                    display: 'flex',
                    width: 500,
                    height: 230,
                    flexWrap: 'wrap',
                    alignContent: 'space-between',
                    margin: '20px auto 10px',
                  }}
                >
                  {result}
                </div>
              );
            })()}
            <p style={{ textAlign: 'center' }}>
              {t('최종수정일', {
                date: modal.params['lastDttm'],
              })}
            </p>
          </>
        ))}
      {modal.type === 'targets' &&
        (() => {
          let converList = [];
          for (let targetKey in pcodeList) {
            converList.push({
              label: pcodeList[targetKey]['codeDesc'],
              value: pcodeList[targetKey]['codeVal'],
            });
          }

          return (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignContent: 'center',
                minHeight: 100,
              }}
            >
              <div style={{ width: 200, marginRight: 10 }}>
                <FilterCollection
                  label={t('타겟팅')}
                  name="key"
                  params={modal.params}
                  value={modal.params.key}
                  type="select"
                  list={converList}
                  callBack={getModalParam}
                  labelKey="label"
                  valueKey="value"
                  popoverHeight={250}
                />
              </div>
              <NewInput
                // label={t('가중치')}
                name="value"
                value={modal.params['value']}
                params={modal.params}
                callBack={getModalParam}
                style={{ width: 70 }}
              />
            </div>
          );
        })()}
    </Modal>
  );
};

export default withRouter(TargetStatisticsModal);
